import MiddleContent from "./middleContent";

export default MiddleContent;
